import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import {
  pagingNutraceuticals,
  getNutraceuticalsById,
  deleteNutraceuticals,
  saveNutraceuticals,
} from "app/services/NutraceuticalsService";
import { pagingQuantityUnit } from "app/services/QuantityUnitService";
import { pagingDrugRoute } from "app/services/DrugRouteService";
import { Nutraceuticals } from "app/common/Model/Nutraceuticals";

export default class NutraceuticalsStore {
  listAllNutraceuticals = [];
  searchNutraceuticals = new SearchObject();
  pageNutraceuticals = null;
  selectedNutraceuticals = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteNutraceuticals = false;
  listUnit = [];
  listDrugRoute = [];

  constructor() {
    makeAutoObservable(this);
  }

  getListUnitAndListDrugRoute = async () => {
    try {
      const res = await pagingQuantityUnit(this.searchNutraceuticals);
      const res_2 = await pagingDrugRoute(this.searchNutraceuticals);
      this.listUnit = res.data.content;
      this.listDrugRoute = res_2.data.content;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  pagingNutraceuticals = async () => {
    try {
      const res = await pagingNutraceuticals(this.searchNutraceuticals);
      this.pageNutraceuticals = res.data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  handleChangeFormSearch = (searchNutraceuticals) => {
    this.searchNutraceuticals = checkSearchObject(
      this.searchNutraceuticals,
      searchNutraceuticals
    );
    this.pagingNutraceuticals();
  };

  handleOpenFormCreateOrEdit = async (nutraceuticalsId) => {
    try {
      if (Boolean(nutraceuticalsId)) {
        const res = await getNutraceuticalsById(nutraceuticalsId);
        this.selectedNutraceuticals = res.data;
        this.openFormCreateOrEdit = true;
      } else {
        this.selectedNutraceuticals = new Nutraceuticals();
        this.openFormCreateOrEdit = true;
      }
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  saveNutraceuticals = async (nutraceuticals, { setSubmitting }) => {
    try {
      await saveNutraceuticals(nutraceuticals);
      this.selectedNutraceuticals = null;
      toast.success("Lưu thông tin thực phẩm chức năng thành công!");
      this.handleClosePopup();
      this.pagingNutraceuticals();
      setSubmitting(false);
    } catch (error) {
      console.error(error);
      toast.error("Lưu thông tin thực phẩm chức năng có lỗi");
    }
  };

  handleDeleteNutraceuticals = (nutraceuticals) => {
    this.selectedNutraceuticals = { id: nutraceuticals.id };
    this.openConfirmDeleteNutraceuticals = true;
  };

  handleConfirmDeleteNutraceuticals = async () => {
    try {
      await deleteNutraceuticals(this.selectedNutraceuticals?.id);
      if (
        this.searchNutraceuticals?.pageIndex > 1 &&
        this.searchNutraceuticals?.content?.length === 1
      ) {
        this.searchNutraceuticals.pageIndex -= 1;
      }
      toast.success("Xóa đơn vị thực phẩm chức năng thành công!");
      this.handleClosePopup();
      this.pagingNutraceuticals();
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteNutraceuticals = false;
  };

  resetStore = () => {
    this.searchNutraceuticals = new SearchObject();
    this.pageNutraceuticals = null;
    this.selectedNutraceuticals = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteNutraceuticals = false;
  };
}
